import React, { Component } from "react";
import { connect } from "react-redux";
import HotKeysModal from "Components/HotKeysModal";
import Notice from "Components/Notice";
import DefdocListGridRef from "Components/Refers/DefdocListGridRef";
import { langCheck } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
import DataPermissionArea from './components/DataPermissionArea';
const { NCRadio } = platform.base;
//自定义档案模态框组件类
class CustomModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initVal: this.props.initVal,
            refname: this.props.refname,
            showfocus: this.props.showfocus,
            iscode: this.props.iscode,
            onlyLeafCanSelect: this.props.onlyLeafCanSelect,
            isdatapowerenable: this.props.isdatapowerenable,
            isgrade: "", //用于判断自定义档案默认值显示树参照还是列表参照 Y:树参照 N:列表参照
            json: {},
        };
    }
    //更新自定义档案取值
    componentWillReceiveProps(nextProps) {
        //弹框首次显示时
        if(nextProps.modalVisibel && nextProps.modalVisibel && !this.props.modalVisibel) {
            // porps发生变化时执行,初始化render时不执行
            this.setState({
                initVal: nextProps.initVal,
                refname: nextProps.refname,
                showfocus: nextProps.showfocus,
                iscode: nextProps.iscode,
                onlyLeafCanSelect: nextProps.onlyLeafCanSelect,
                isdatapowerenable: nextProps.isdatapowerenable,
                //2207新增使用场景
                datapoweroperationcode: nextProps.selectCard.datapoweroperationcode,
            });

        }
    }
	//设置模态框隐藏
	showModalHidden = () => {
	    this.props.setModalVisibel("customModalVisibel", false);
	};
	//更新dataval字段
	onOkDialog = () => {
	    if(!this.validateSave()) {return;}
	    let { initVal, showfocus, onlyLeafCanSelect, refname, isgrade, isdatapowerenable, datapoweroperationcode } = this.state;
	    if(this.props.isShowSetting) {
	        this.props.handleSelectChange({
	            dataval: initVal,
	            showfocus: showfocus || "1",
	            onlyLeafCanSelect: onlyLeafCanSelect || false,
	            isdatapowerenable: isdatapowerenable || false,
	            refname,
	            defaultvalue: "",
	            isgrade,
	        });
	    } else {
	        //查询区自定义档案只修改refname
	        this.props.handleSelectChange({ refname, dataval: initVal, datapoweroperationcode, isdatapowerenable });
	    }
	    this.showModalHidden();
	};

	componentDidMount() {
	    //多语
	    let callback = json => {
	        this.setState({ json: json });
	    };
	    getMulti({
	        moduleId: "ZoneSetting",
	        domainName: "workbench",
	        callback,
	    });
	}

	//勾选设置showfocus
	checkboxChange = val => {
	    this.setState({ showfocus: val });
	};
	leafChange = val => {
	    this.setState({ onlyLeafCanSelect: val });
	};
	isDataPowerEnableChange = val => {
	    this.setState({ isdatapowerenable: val });
	};

	//保存验证
	validateSave = () => {
	    const { datapoweroperationcode, isdatapowerenable, json } = this.state;
	    //报表查询区选中启用数据权限必须选择使用场景
	    if(isdatapowerenable && !datapoweroperationcode) {
	        Notice({ status: "warning", msg: langCheck("ZoneSetting-000357", "pages", json) }); //使用场景不能为空
	        return false;
	    }
	    return true;
	}
	
	handleStateChange = (key, val) => {
	    this.setState({ [key]: val });
	}
	render() {
	    let { initVal, showfocus, iscode, onlyLeafCanSelect, refname, json, isdatapowerenable, datapoweroperationcode } = this.state;
	    return (
	        <div className='myZoneModal'>
	            <HotKeysModal
	                closable={false}
	                title={langCheck(
	                    "ZoneSetting-000022",
	                    "pages",
	                    json,
	                )} /* 国际化处理： 类型设置*/
	                wrapClassName='zonesetting-customModal'
	                visible={this.props.modalVisibel}
	                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
	                cancelText={langCheck(
	                    "ZoneSetting-000006",
	                    "pages",
	                    json,
	                )} /* 国际化处理： 取消*/
	                onOk={this.onOkDialog}
	                destroyOnClose={true}
	                onCancel={this.showModalHidden}
	                fieldid='custom'>
	                <div className='def-refer'>
	                    <DefdocListGridRef
	                        value={{
	                            refpk: initVal || 'test', //加个占位字符，不然refpk为空时不显示名称
	                            refname: refname,
	                            refcode: "",
	                        }}
	                        placeholder={langCheck(
	                            "ZoneSetting-000023",
	                            "pages",
	                            json,
	                        )} /* 国际化处理： 自定义档案*/
	                        fieldid='defdocList'
	                        onChange={val => {
	                            this.setState({
	                                initVal: val && val.refpk,
	                                refname: val && val.refname,
	                                isgrade:
										val &&
										val.values &&
										val.values.isgrade &&
										val.values.isgrade.value,
	                            });
	                        }}
	                    />
	                </div>
	                {
	                    this.props.isShowSetting && (
	                        <div className='mdcontent'>
	                            <div className='mdcontentItem'>
	                                <span className='refer_label'>
	                                    {langCheck("ZoneSetting-000070", "pages", json)}
	                                    {/* /* 国际化处理： 焦点离开后参照显示编码:*/}
	                                </span>
	                                <NCRadio.NCRadioGroup
	                                    selectedValue={
	                                        showfocus ||
											(iscode ? (iscode === true ? "0" : "1") : "1")
	                                    }
	                                    onChange={this.checkboxChange}>
	                                    <NCRadio value='0'>
	                                        {langCheck("ZoneSetting-000081", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value='1'>
	                                        {langCheck("ZoneSetting-000131", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value='2'>
	                                        {langCheck("ZoneSetting-000243", "pages", json)}
	                                    </NCRadio>
	                                </NCRadio.NCRadioGroup>
	                            </div>
	                            <div className='mdcontentItem'>
	                                <span className='refer_label'>
	                                    {langCheck("ZoneSetting-000232", "pages", json)}
	                                    {/* /* 国际化处理： 是否可以选择非叶子节点:*/}
	                                </span>
	                                <NCRadio.NCRadioGroup
	                                    selectedValue={onlyLeafCanSelect || false}
	                                    onChange={this.leafChange}>
	                                    <NCRadio value={true}>
	                                        {langCheck("ZoneSetting-000229", "pages", json)}
	                                    </NCRadio>
	                                    <NCRadio value={false}>
	                                        {langCheck("ZoneSetting-000230", "pages", json)}
	                                    </NCRadio>
	                                </NCRadio.NCRadioGroup>
	                            </div>
	                            {/* /* 国际化处理： 是否启用数据权限:*/}
	                            {/* <div className='mdcontentItem'>
									<span className='refer_label'>
										{langCheck("ZoneSetting-000327", "pages", json)}
									</span>
									<NCRadio.NCRadioGroup
										selectedValue={isdatapowerenable || false}
										onChange={this.isDataPowerEnableChange}>
										<NCRadio value={true}>
											{langCheck("ZoneSetting-000229", "pages", json)}
										</NCRadio>
										<NCRadio value={false}>
											{langCheck("ZoneSetting-000230", "pages", json)}
										</NCRadio>
									</NCRadio.NCRadioGroup>
								</div> */}
	                        </div>
	                    )
	                }
	                {/* 报表查询区非元数据显示数据权限 */}
	                {this.props.isreport && !this.props.selectCard.metapath && (
	                    <DataPermissionArea
	                        dataSource={{
	                            isdatapowerenable,
	                            datapoweroperationcode,
	                        }}
	                        referData={{
	                            refpk: initVal,
	                            pk: initVal,
	                        }}
	                        json={json}
	                        onDataPowerEnableChange={this.handleStateChange.bind(
	                            this,
	                            "isdatapowerenable",
	                        )}
	                        onUsedSceneChange={this.handleStateChange.bind(
	                            this,
	                            "datapoweroperationcode",
	                        )}
	                    />
	                )}
	            </HotKeysModal>
	        </div>
	    );
	}
}
export default connect(
    state => ({
        selectCard: state.zoneSettingData.selectCard,
        areaList: state.zoneSettingData.areaList,
        isreport: state.zoneSettingData.isreport,
    }),
    {},
)(CustomModal);
